import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FormInput from '@ui/forms/Input/FormInput'
import FormInputDate from '@ui/forms/Date/FormInputDate'
import FormSelect from '@ui/forms/Select/FormSelect'
import InputsSection from '@ui/forms/InputsSection'
import FormSection, { FormRow } from './FormSection'
import {
  CofidisMonthlyApplicationFormValues,
  CofidisSectionProps,
} from '../types'
import { EditionModeValues, EditionMode } from '../enums'

export default function BankingSection({ fieldSuccess }: CofidisSectionProps) {
  const { t } = useTranslation(['cofidis'])
  const { control } = useFormContext<CofidisMonthlyApplicationFormValues>()
  const editionModeOptions = useMemo(
    () =>
      EditionModeValues.map((option) => ({
        value: option,
        label: t(`cofidis:editionMode.options.${EditionMode[option]}.label`),
      })),
    [t]
  )

  return (
    <InputsSection group>
      <FormSection>
        <FormRow>
          <FormInput
            required
            labelVariant="top"
            name="iban"
            isSuccess={fieldSuccess?.iban}
            label={t('cofidis:iban.label')}
            autoCapitalize="characters"
            next="bankAccountHolderName"
          />
        </FormRow>
        <FormRow>
          <FormInput
            required
            labelVariant="top"
            name="bankAccountHolderName"
            isSuccess={fieldSuccess?.bankAccountHolderName}
            label={t('cofidis:bankAccountHolderName.label')}
            autoCapitalize="words"
            next="bankAccountOpeningDate"
          />
          <FormInputDate
            labelVariant="top"
            name="bankAccountOpeningDate"
            isSuccess={fieldSuccess?.bankAccountOpeningDate}
            label={t('cofidis:bankAccountOpeningDate.label')}
          />
        </FormRow>
        <FormRow>
          <FormSelect
            disabled={true} // TODO: verify me
            required
            labelVariant="top"
            control={control}
            name="editionMode"
            isSuccess={fieldSuccess?.editionMode}
            label={t('cofidis:editionMode.label')}
            options={editionModeOptions}
          />
        </FormRow>
      </FormSection>
    </InputsSection>
  )
}
